import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router, RouterModule } from '@angular/router';
import {
  NgbDropdownModule,
  NgbModalModule,
  NgbNavModule
} from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../services/auth.service';
import { HasRoleDirective } from '../directives/has-role.directive';

@Component({
  selector: 'app-top-bar',
  standalone: true,
  imports: [
    CommonModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbModalModule,
    RouterModule,
    HasRoleDirective
  ],
  template: `<nav
    class="navbar navbar-brand sticky-top justify-content-start h-100 p-2 align-content-center"
  >
    <a role="button" (click)="reload()" class="logo-image">
      <img
      class="w-100"
        src="/public/img/TIM_ENTERPRISE_Vert_Pos-RGB.png"
        alt=""
      />
    </a>

    <span class="nv-color-tim ms-2">Professional Services</span>
    <div class="vr mx-2 mx-lg-3 nv-color-tim" style="height: 3rem;"></div>

    <ul class="navbar-nav flex-row ms-4 gap-4 align-items-center" *appHasRole="['admin','portfolio']">
      <li class="nav-item">
        <a class="nav-link fw-bold nv-color-tim" routerLink="/" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact: true}" style="cursor: pointer;">HOME</a>
      </li>
      <li class="nav-item">
        <a class="nav-link fw-bold nv-color-tim" routerLink="/report" [routerLinkActive]="'active'" style="cursor: pointer;">REPORT</a>
      </li>
    </ul>

    <div ngbDropdown display="dynamic" placement="bottom-end" class="ms-auto pe-md-3">
      <img
        [src]="authService.userImage"
        alt=""
        width="35"
        class="align-text-top user-image"
        id="userOption"
        href="#"
        tabindex="0"
        ngbDropdownToggle
        role="button"
      />
      <div ngbDropdownMenu aria-labelledby="userOption" class="dropdown-menu">
        <b class="ms-3 mx-5">{{ (fireAuth.user | async)?.email }}</b>
        <div class="dropdown-divider"></div>
        <button ngbDropdownItem (click)="authService.logout()" class="ps-3">
          Logout
        </button>
      </div>
    </div>
  </nav> `,
  styleUrls: ['./top-bar.component.css']
})
export class TopBarComponent {
  private readonly router = inject(Router);
  public readonly fireAuth = inject(AngularFireAuth);
  public readonly authService = inject(AuthService);

  async reload() {
    await this.router.navigate(['/landing']);
    location.reload();
  }
}
